import icons from '@loggi/ui/components/utils/icons';

// COLORS
export const ACTIVE_COLOR = 'active';
export const INFO_COLOR = 'info';
export const SUCCESS_COLOR = 'success';
export const DANGER_COLOR = 'danger';
export const WARNING_COLOR = 'warning';
export const WHITE_COLOR = 'white';

// STYLES
export const PRIMARY_STYLE = 'primary';
export const OUTLINE_STYLE = 'outline';
export const LINK_STYLE = 'link';
export const LIGHT_STYLE = 'light';
export const INVERSE_STYLE = 'inverse';

// SHAPES
export const SQUARE_SHAPE = 'square';
export const ROUNDED_SHAPE = 'rounded';
export const CIRCLE_SHAPE = 'circle';

// SIZES
export const SMALL_SIZE = 'small';
export const REGULAR_SIZE = 'regular';
export const LARGE_SIZE = 'large';
export const LG_SIZE = 'lg';
export const SM_SIZE = 'sm';
export const XS_SIZE = 'xs';

export const COLORS = [
  ACTIVE_COLOR,
  INFO_COLOR,
  SUCCESS_COLOR,
  DANGER_COLOR,
  WARNING_COLOR
];
export const STYLES = [
  PRIMARY_STYLE,
  OUTLINE_STYLE,
  LINK_STYLE,
  LIGHT_STYLE,
  INVERSE_STYLE
];
export const SHAPES = [SQUARE_SHAPE, ROUNDED_SHAPE, CIRCLE_SHAPE];
export const SIZES = [
  SMALL_SIZE,
  REGULAR_SIZE,
  LARGE_SIZE,
  LG_SIZE,
  SM_SIZE,
  XS_SIZE
];
export const ICONS = icons.names;
